export default __webpack_public_path__ + "static/media/simone@2x.9bd02060.png";